var map = {
	"./menuItemsAdmin": "ac31",
	"./menuItemsAdmin.js": "ac31",
	"./menuItemsRoot": "16f0",
	"./menuItemsRoot.js": "16f0",
	"./menuItemsUser": "69f9",
	"./menuItemsUser.js": "69f9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "46a2";